import React from "react";
import Modal from "../modal-new";

const VelocityExplanation = () => {
  return (
    <Modal
      title={"Estimated Velocity based 1Rep Max"}
      className={"velocity-explanation-modal"}
    >
      <div className="body">
        <p className="p5">
          Estimated Velocity based 1Rep Max (v1RM), is a lifter’s calculated
          maximum strength levels derived from a series of sub-maximal sets with
          velocity data; all without the need to perform an actual maximal
          repetition.
        </p>
        <p className="p5 mt-2">
          To find an v1RM value, we need to use some basic mathematics and have
          an understanding of two core concepts: the load velocity-profile, and
          the minimum velocity threshold.
        </p>
        <p className="p5 mt-2">
          The load velocity-profile will be plotted as a lifter logs their
          velocity data.
        </p>
        <p className="p5 mt-2 mb-6">
          The second element of the v1RM equation is the minimum velocity
          threshold (MVT). This is the velocity that corresponds with a lifter’s
          1RM. It’s literally the slowest speed at which a lifter can
          successfully complete a rep for the given exercise. Think of this as
          the end of the line for your load-velocity profile. In practical terms
          this represents your ability to produce enough acceleration on the
          weight to overcome gravity, any slower and the rep would be a fail.
        </p>
      </div>
    </Modal>
  );
};

export default VelocityExplanation;
